import { render, staticRenderFns } from "./ISubmit.vue?vue&type=template&id=5a31401e&"
import script from "./ISubmit.vue?vue&type=script&lang=js&"
export * from "./ISubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports